import * as React from "react";
import { StyledSelect, StyledTextField } from "../../../../styles/form";
import { FieldError, FormAutoSelectError } from "../../../../styles/general";
import Select, { createFilter } from "react-select";
import {
  StyledFormControl,
  StyledAutoSelectInputLabel,
} from "../../../../styles/form";
// import MenuItem from "@material-ui/core/MenuItem";

// Form select component
export const FormSelectComponent: any = ({
  input,
  label,
  disabled,
  onChange,
  required,
  meta: { touched, error },
  children,
  ...custom
}: {
  input: any;
  label: any;
  disabled: boolean;
  onChange: any;
  required: boolean;
  meta: any;
  children: any;
  custom: any;
}) => {
  return (
    <React.Fragment>
      <StyledSelect
        disabled={disabled}
        error={touched && error ? true : false}
        onChange={onChange}
        {...input}
        children={children}
        {...custom}
      />
      {touched && error && <FieldError>{error}</FieldError>}
    </React.Fragment>
  );
};

// Form select(autocomplete) component
export const FormSelectAutoCompleteComponent: any = ({
  input,
  label,
  name,
  disabled,
  onChange,
  meta: { touched, error },
  children,
  data,
  classes,
  value,
  isMulti,
  onInputChange,
  menuIsOpen,
  required,
  ...custom
}: {
  input: any;
  label: any;
  name: any;
  disabled: boolean;
  onChange: any;
  meta: any;
  children: any;
  custom: any;
  data: any;
  value: any;
  classes: any;
  isMulti: boolean;
  onInputChange: any;
  menuIsOpen: boolean;
  required: any;
}) => {
  return (
    <React.Fragment>
      <StyledFormControl>
        <StyledAutoSelectInputLabel>
          <span className={touched && error ? "req-label" : ""}>
            {label} {required ? <span>*</span> : null}
          </span>
        </StyledAutoSelectInputLabel>

        <Select
          className={[touched && error ? "req-field-error-autosel" : ""]}
          options={data}
          components={components}
          isDisabled={disabled}
          onBlur={input.onBlur}
          value={input.value}
          placeholder="Please Select"
          isMulti={isMulti || false}
          error={touched && error ? true : false}
          onInputChange={onInputChange}
          menuIsOpen={menuIsOpen}
          isClearable={true}
          styles={stylesReactSelect}
          filterOption={createFilter({ ignoreAccents: false })}
          {...input}
          {...custom}
        />
        {touched && error && <FormAutoSelectError>{error}</FormAutoSelectError>}
      </StyledFormControl>
    </React.Fragment>
  );
};

const components = {
  Control,
  Option,
};

function inputComponent({
  index,
  key,
  inputRef,
  ...props
}: {
  index: any;
  key: any;
  inputRef: any;
  props: any;
}) {
  return <div key={key} ref={inputRef} {...props} />;
}

function Control(props: any) {
  return (
    <StyledTextField
      setwidth={props.selectProps.name}
      InputProps={{
        inputComponent,
        inputProps: {
          children: props.children,
          className: props.selectProps.classes
            ? props.selectProps.classes.input
            : "autoselect-material",
          ref: props.innerRef,
          ...props.innerProps,
        },
      }}
    />
  );
}

function Option(props: any) {
  const { onMouseMove, onMouseOver, ...newInnerProps } = props.innerProps;
  return (
    <div {...newInnerProps} className="autoselect-options">
      {props.children}
    </div>
    // <MenuItem
    //   key={props.data.key}
    //   buttonRef={props.innerRef}
    //   selected={props.isFocused}
    //   component="div"
    //   {...newInnerProps}
    //   style={{ zIndex: 999, fontWeight: props.isSelected ? 500 : 400 }}
    // >
    //   {props.children}
    // </MenuItem>
  );
}

const stylesReactSelect = {
  clearIndicator: (provided: any, state: any) => ({
    ...provided,
    cursor: "pointer",
  }),
  indicatorSeparator: (provided: any, state: any) => ({
    ...provided,
    margin: 0,
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    cursor: "pointer",
  }),
};
